import storeApis from "../../api/storeApi";
import "react-toastify/dist/ReactToastify.min.css";
import * as types from "../../constants/DashboardActionTypes";
import _ from "lodash";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";




export const setDashboardUnauthorized = () => {
    // console.log("setDashboardUnauthorizedCALLED");
    return (dispatch) => {
        dispatch({ type: "UNAUTHORIZED_DASHBOARD", payload: null });
    };
};
// getConversation
export const fetchDashboardData = (authToken, startDate,endDate) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
              "dashboard/dashboard_data",
               {
                from_date: startDate,
                to_date: endDate,
               },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_DASHBOARD",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }else if(response.data.statusCode == "400"){
                       Toast(response.data.message, "E");
                       dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
                 else {
                    // Toast(response.data.message, "S");
                    await dispatch({
                      type: types.FETCH_DASHBOARD_DATA,
                      payload: null,
                    });
                    dispatch({
                      type: types.FETCH_DASHBOARD_DATA,
                      payload: response?.data,
                    });
                    // await dispatch(fetchLeadsList(authToken));
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            Toast(err.response.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_DASHBOARD", payload: err.response.status });
        }
    };
  };
export const accountData = (authToken, af,inf,saf) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        try {
            const response = await storeApis.post(
              "dashboard/accounts-dashboard",
               {
                account_filter: af,
                industry_filter: inf,
                starred_account_filter: saf,
               },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.status === 200) {
                if (response.data.statusCode == "403") {
                    // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
                        dispatch({
                            type: "UNAUTHORIZED_DASHBOARD",
                            payload: response.data.statusCode,
                        });
                    // } else {
                    //     Toast(response.data.message, "E");
                    // }
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }else {
                    // Toast(response.data.message, "S");
                    // await dispatch(fetchLeadsList(authToken));
                    dispatch({ type: "ACCOUNT_DASH", payload: response?.data });
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
                }
            }
        } catch (err) {
            Toast(err.response.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_DASHBOARD", payload: err.response.status });
        }
    };
  };
